var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: {
        "patsnap-biz-smart_search": true,
        "ai-common-smart-search": true,
        "ai-common-smart-search--blur":
          !_vm.config.noAutoScroll &&
          _vm.baseMixin__editorStatus !== _vm.DOM_EVENT_FOCUS,
        "ai-common-smart-search--focus":
          !_vm.config.noAutoScroll &&
          _vm.baseMixin__editorStatus === _vm.DOM_EVENT_FOCUS,
        "ai-common-smart-search--readonly": !_vm.contenteditable,
      },
    },
    [
      _vm.config.editorType === _vm.EDITOR_TYPE_DIV_INPUT
        ? _c("div", {
            class: {
              "editor-container": true,
              "editor-container--show-error": _vm.errorVisible,
              "div-input": true,
            },
            attrs: {
              placeholder: _vm.config.placeHolder,
              contenteditable: _vm.contenteditable,
              spellcheck: "false",
            },
          })
        : _vm._e(),
      _vm.config.editorType === _vm.EDITOR_TYPE_DIV_TEXTAREA
        ? _c("div", {
            staticClass: "editor-container div-textarea",
            class: {
              "editor-container--show-error": _vm.errorVisible,
            },
            attrs: {
              placeholder: _vm.config.placeHolder,
              contenteditable: _vm.contenteditable,
              spellcheck: "false",
            },
          })
        : _vm._e(),
      _vm.config.editorType === _vm.EDITOR_TYPE_INPUT
        ? _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.inputModeMixin__query,
                expression: "inputModeMixin__query",
              },
            ],
            staticClass: "editor-container input",
            attrs: {
              placeholder: _vm.config.placeHolder,
              type: "text",
              spellcheck: "false",
            },
            domProps: { value: _vm.inputModeMixin__query },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.inputModeMixin__query = $event.target.value
              },
            },
          })
        : _vm._e(),
      _vm.config.editorType === _vm.EDITOR_TYPE_TEXTAREA
        ? _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.inputModeMixin__query,
                expression: "inputModeMixin__query",
              },
            ],
            staticClass: "editor-container textarea",
            attrs: {
              placeholder: _vm.config.placeHolder,
              spellcheck: "false",
              type: "text",
            },
            domProps: { value: _vm.inputModeMixin__query },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.inputModeMixin__query = $event.target.value
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("suggestion-modal", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.suggestionList.length > 0 &&
              _vm.baseMixin__editorStatus === _vm.DOM_EVENT_FOCUS,
            expression:
              "suggestionList.length > 0 && baseMixin__editorStatus === DOM_EVENT_FOCUS",
          },
        ],
        staticClass: "suggestion-modal",
        class: {
          "full-width-modal":
            _vm.config.editorType === _vm.EDITOR_TYPE_TEXTAREA ||
            _vm.config.editorType === _vm.EDITOR_TYPE_INPUT,
        },
        attrs: {
          "drop-data": _vm.dropData,
          suggestion: _vm.suggestionList,
          position: _vm.modalPos,
          "analytics-domain": _vm.analyticsDomain,
          "special-suggest-request": _vm.specialSuggestRequest,
          stem: _vm.currentStem,
        },
        on: {
          "select-option": _vm.selectOptionHandler,
          "preview-option": _vm.previewOption,
          "update-selected-index": _vm.baseMixin__updateSelectedIndex,
        },
      }),
      _vm.fieldList.length > 0
        ? _c("field-list", {
            style: _vm.fieldListPos,
            attrs: { "field-list": _vm.fieldList },
            on: { "select-field": _vm.divModeMixin__clearFieldList },
          })
        : _vm._e(),
      _vm.showErrorModal
        ? _c("error-modal", {
            attrs: {
              "error-modal-data": _vm.inputModeMixin__errorModalData,
              "editor-status": _vm.baseMixin__editorStatus,
              config: _vm.config,
            },
          })
        : _vm._e(),
      _vm.divModeMixin__tipData
        ? _c("error-tip", {
            attrs: { "tip-data": _vm.divModeMixin__tipData },
            nativeOn: {
              mouseenter: function ($event) {
                return _vm.divModeMixin_clearSymbolTip(false)
              },
              mouseleave: function ($event) {
                return _vm.divModeMixin_clearSymbolTip(true)
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }